module.exports = __webpack_public_path__ + "static/media/GT-Walsheim-Light.3def1cf4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/GT-Walsheim-Light.svg
// module id = 659
// module chunks = 0